export const hotelCategoryChatterType = [
    {id: 'checkin', name: 'Check In'},
    {id: 'checkout', name: 'Check Out'},
    {id: 'stay', name: 'Stay'},
    {id: 'guest', name: 'Guest'}
];
